/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';

import {
    Container, Box, Grid, Typography,
} from '@mui/material';
import { styled } from '@mui/system';

import questionsData from 'utils/questions';

import Bar from '../../Charts/Bar';
import StackedBar from '../../Charts/StackedBar';
import AppFooterNav from '../AppFooterNav';

import Filters from '../Filters';

const QuestionsWrapper = styled(Box, {})(({ theme }) => ({
    // width: '100%',
    // height: 'calc(100% - 38px)',
    // position: 'relative',
    // paddingTop: 10,
    // paddingBottom: 10,
    // paddingRight: 20,
    // paddingLeft: 20,
    // top: '38px',
    // '.slide': {
    //     padding: '0 5px',
    // },
}));

const mapQuestions = (question) => {
    if (question === 'How much could you increase revenue by leveraging your SAP data outside of SAP?') {
        return 'How much could you INCREASE REVENUE by leveraging your SAP data outside of SAP?';
    } if (question === 'How much could you reduce expenses by leveraging your SAP data outside of SAP?') {
        return 'How much could you REDUCE EXPENSES by leveraging your SAP data outside of SAP?';
    }
    if (question === 'Benefit did/would your organisation expect to gain from replicating its SAP data into the cloud for analytics') {
        return 'Which of these benefits do you expect to gain from replicating its SAP data into the cloud for analytics';
    }
    if (question === 'How do you think replicating SAP data into the cloud for analytics has impacted/will impact the following area at your organisation?') {
        return 'How do you think replicating SAP data into the cloud for analytics has impacted/will impact your organisation?';
    }
    if (question === 'If you are analysing  your SAP data from a data warehouse or data lake, what is the current latency for your SAP data?') {
        return 'If you are analysing  your SAP data from a data warehouse or data lake, what is the CURRENT latency for your SAP data?';
    }
    if (question === 'If you are analysing  your SAP data from a data warehouse or data lake, what is the optimal latency for your SAP data?') {
        return 'If you are analysing  your SAP data from a data warehouse or data lake, what is the OPTIMAL latency for your SAP data?';
    }
    if (question === 'Using SAP ECC today, where is your organisation running SAP ERP?') {
        return 'Using SAP ECC today';
    }
    if (question === 'Using SAP S4/HANA today, where is your organisation running SAP S4/HANA?') {
        return 'Using SAP S4/HANA today';
    }
    return question;
};

const Questions = ({ group, percentageChecked, featured }) => {
    const filteredQuestionsData = questionsData.filter((question) => question.group === group);

    // const chunks = [];
    // for (let i = 0; i < filteredQuestionsData.length; i += 4) {
    //     chunks.push(filteredQuestionsData.slice(i, i + 4));
    // }

    return (
        <QuestionsWrapper>
            <Container maxWidth="xl">

                <Grid container spacing={2}>
                    {

                        filteredQuestionsData.map((c) => {
                            if (c.type === 'bar') {
                                return (
                                    <Grid item sm={6} key={c.question}>
                                        <Bar
                                          title={mapQuestions(c.question)}
                                          options={{
                                                dimension: c.dimension,
                                                measure: c.measure,
                                                measureLabel: c.measureLabel,
                                                measureAlt: c.measureAlt,
                                                measureAltLabel: c.measureAltLabel,
                                                sortBy: c.sortBy,
                                            }}
                                          percentageChecked={percentageChecked}
                                          feature={c.featured}
                                        />
                                    </Grid>
                                );
                            } if (c.type === 'stacked') {
                                return (
                                    <Grid item sm={c.width === 'full' ? 12 : 6} key={c.question}>
                                        <StackedBar
                                          title={mapQuestions(c.question)}
                                          options={{
                                                dimension: c.dimension,
                                                dimensionStack: c.dimensionStack,
                                                measure: c.measure,
                                                measureAlt: c.measureAlt,
                                                sortBy: c.sortBy,
                                                sortDir: c.sortDir,
                                            }}
                                          percentageChecked={percentageChecked}
                                          height={c.question === "To what extent, if at all, have the following hindered your organisation's integration of its SAP ERP data?" ? '450px' : '300px'}
                                        />
                                    </Grid>
                                );
                            }
                            return <></>;
                        })

                    }
                </Grid>

            </Container>
        </QuestionsWrapper>
    );
};

Questions.propTypes = {
    group: PropTypes.string,
    percentageChecked: PropTypes.bool,
    featured: PropTypes.bool,
};

Questions.defaultProps = {
    group: '',
    percentageChecked: true,
    featured: false,
};

export default Questions;
